import { render, staticRenderFns } from "./customizeDown.vue?vue&type=template&id=66028316&scoped=true&"
import script from "./customizeDown.vue?vue&type=script&lang=js&"
export * from "./customizeDown.vue?vue&type=script&lang=js&"
import style0 from "./customizeDown.vue?vue&type=style&index=0&id=66028316&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66028316",
  null
  
)

component.options.__file = "customizeDown.vue"
export default component.exports